import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getBlog, setReadBlog } from "../firebase/functions/blogs";

import { Blog_Type, Content_Enums } from "../model";
import CopyIcon from "@mui/icons-material/ContentCopy";
import copy from "clipboard-copy";

import Code from "../components/contents/Code";
import Image from "../components/contents/Image";
import Text from "../components/contents/Text";
import Title from "../components/contents/Title";
import UlText from "../components/contents/UlText";
import Video from "../components/contents/Video";
import Loading from "../components/Loading";

function Blog() {
  const { id } = useParams();
  const [currentBlog, setCurrentBlog] = useState<Blog_Type>({} as Blog_Type);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (id) {
      setLoading(true);
      getBlog(id)
        .then((blog) => {
          blog && setCurrentBlog(blog);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  useEffect(() => {
    // obeserver
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (id) {
            setReadBlog(id).then(() => {
              console.log("blog is read");
            });
          }
        }
      });
    });

    observer.observe(document.querySelector("#blog")!);
  }, [id]);

  return (
    <div id="blog" className="w-full max-w-5xl p-6 mx-auto">
      {loading && <Loading />}
      {currentBlog && currentBlog.id && (
        <div>
          {/* title */}
          <div className="mb-4 text-left">
            <p className="text-black text-2xl font-semibold">
              {currentBlog.title}
            </p>
          </div>
          {/* author */}
          <div className="mb-4">
            <p className="text-gray-500 text-md font-semibold">
              {currentBlog.author}
            </p>
          </div>
          {/* summary */}
          <div className="mb-4">
            <p className="text-gray-700 text-md font-semibold">
              {currentBlog.summary}
            </p>
          </div>
          {/* content */}
          <div className="mb-4 flex flex-col gap-4">
            {currentBlog.content.map((content, index) => (
              <div key={index} className="relative">
                {content.type === Content_Enums.CODE && (
                  <Code>{content.content as string}</Code>
                )}
                {content.type === Content_Enums.IMAGE && (
                  <Image>{content.content as string}</Image>
                )}
                {content.type === Content_Enums.TEXT && (
                  <Text>{content.content as string}</Text>
                )}
                {content.type === Content_Enums.TITLE && (
                  <Title>{content.content as string}</Title>
                )}
                {content.type === Content_Enums.UL && (
                  <UlText>{content.content as string[]}</UlText>
                )}
                {content.type === Content_Enums.VIDEO && (
                  <Video>{content.content as string}</Video>
                )}

                {content.type === Content_Enums.CODE && (
                  <div className="absolute top-0 left-0 flex flex-col">
                    <button
                      onClick={() => copy(content.content as string)}
                      className=" hover:bg-slate-500 p-2 rounded-full"
                    >
                      <CopyIcon className="text-white" />
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
          {/* date */}
          <div className="mb-4 flex justify-end">
            <p className="text-gray-500 text-md font-semibold">
              {new Date(currentBlog.date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
          </div>
          {/* nu,ber of reads */}
          <div className="mb-4 flex justify-start">
            <p className="text-gray-500 text-xs font-semibold">
              Number Of Visiting: {currentBlog.numberOfReads}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Blog;
